import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../stores';
import { CircularProgress, Box } from '@mui/material';

const VerifyEmailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const verifyEmail = useAuthStore(state => state.verifyEmail);
  const { t } = useTranslation();

  const [status, setStatus] = useState('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {

    const token = new URLSearchParams(location.search).get('token');
    if (!token) {
      setErrorMessage(t('auth.error.no_token', 'No token provided.'));
      setStatus('error');
      return;
    }

    verifyEmail(token).then(result => {
      if (result.success) {
          setStatus('success');
          setTimeout(() => {
            navigate('/');
          }, 2000);
        } else {
          setErrorMessage(t(result.error));
          setStatus('error');
        }
      });
  }, [location.search, navigate, verifyEmail, t]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8 }}>
      {status === 'loading' && (
        <>
          <CircularProgress />
          <div>
            {t('auth.verify_email.verifying', 'Verifying your email...')}
          </div>
        </>
      )}
      {status === 'success' && (
        <>
          <div>
            {t('auth.verify_email.verified', 'Email verified! Redirecting...')}
          </div>
        </>
      )}
      {status === 'error' && (
        <>
          <div>
            {errorMessage}
          </div>
        </>
      )}
    </Box>
  );
};

export default VerifyEmailPage;
